(() => {
  let signature = '', loaded = false;
  function loadIcons() {
    const nodes = [...document.querySelectorAll('[data-google-icon]')];
    const names = [...new Set(nodes.map(n => n.dataset.googleIcon).filter(n => /^[a-z][a-z0-9_]*$/.test(n)))].sort();
    if (!names.length) return;
    const next = names.join(',');
    const reveal = () => document.querySelectorAll('[data-google-icon]').forEach(n => { if (names.includes(n.dataset.googleIcon)) n.classList.add('is-ready'); });
    if (next === signature) { if (loaded) reveal(); return; }
    signature = next; loaded = false;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0&icon_names=' + encodeURIComponent(next) + '&display=block';
    link.onload = () => document.fonts.load('24px "Material Symbols Outlined"', names.join(' ')).then(() => {
      if (signature !== next) return;
      loaded = true; reveal();
      document.querySelectorAll('link[data-atelier-icons]').forEach(old => { if (old !== link) old.remove(); });
    }).catch(() => {});
    link.dataset.atelierIcons = '';
    document.head.append(link);
  }
  loadIcons();
  document.addEventListener('shopify:section:load', loadIcons);
})();
